module.exports = __webpack_public_path__ + "img/main.e572a65c.png";